import React from "react";
import { Row } from "antd";
import {
  GrantAgreementSectionSubHeading,
  GrantAgreementContent,
} from "../../styles";
import {
  ContentMessage,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import { CommonListWrapper } from "../../../../../../CommonComponents/commonStyles";

const GrantAllocationNote = () => (
  <Row>
    <GrantAgreementContent>
      <GrantAgreementSectionSubHeading>
        Please Note:
      </GrantAgreementSectionSubHeading>
      <CommonListWrapper>
        <ContentMessage
          type={[Types.PAGE_NOTICES]}
          page={"Grant Agreement"}
          html={true}
          property="field_notice_content"
          defaultMessage={""}
        />
      </CommonListWrapper>
    </GrantAgreementContent>
  </Row>
);

export default GrantAllocationNote;
